module.exports = __webpack_public_path__ + "img/ly.e0c5f31f.svg";